// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__6DF2N","button__input":"Button_button__input__K813W"};